import React, { Component } from 'react'
import { Tabs } from 'antd';
import { Table } from 'antd';

const { TabPane } = Tabs;
const columns1 = [
  {
    title: '序号',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: '流程名称',
    dataIndex: 'age',
    key: 'age',
  },
  {
    title: '任务摘要',
    dataIndex: 'address',
    key: 'address',
  },
  {
    title: '送达时间',
    dataIndex: 'date',
    key: 'date',
  },
]
const dataSource = [
  {
    key: '1',
    name: '胡彦斌',
    age: 32,
    address: '西湖区湖底公园1号',
  },
  {
    key: '2',
    name: '胡彦祖',
    age: 42,
    address: '西湖区湖底公园1号',
  },
];
export default class SysInfos extends Component {
  render() {
    return (
      <Tabs defaultActiveKey="1">
        <TabPane tab="我的待办" key="1">
          <Table columns={columns1} dataSource={dataSource} pagination={false} />
        </TabPane>
        <TabPane tab="我的消息" key="2">
          <Table columns={columns1} dataSource={dataSource} pagination={false} />
        </TabPane>
        <TabPane tab="我开立的粮信" key="3">
          <Table columns={columns1} dataSource={dataSource} pagination={false} />
        </TabPane>
        <TabPane tab="即将到期付款(粮信)" key="4">
          <Table columns={columns1} dataSource={dataSource} pagination={false} />
        </TabPane>
        <TabPane tab="即将到期付款(非粮信)" key="5">
          <Table columns={columns1} dataSource={dataSource} pagination={false} />
        </TabPane>
      </Tabs>
    )
  }
}



// WEBPACK FOOTER //
// ./apps/pages/main/layout/SysInfos.js